export const getInitialState = () => ({
    metal_type_product: {}
});

export const HoverProductsDetailReducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case 'GET_HOVER_PRODUCT':
            return {
                ...state,
                metal_type_product: {
                    ...state.metal_type_product,
                    [action?.options?.sku]: { metal_type: action?.options?.metal_type, price_type: action?.options?.price_type }
                }
            };
        default:
            return state;
    }
};

export default HoverProductsDetailReducer;
